import React from "react";

export default function MuldeFrame({
  title,
  children,
  style,
  titleStyle,
  contentStyle,
}) {
  return (
    <section
      style={{
        position: "relative",
        borderRadius: 12,
        background: "rgba(10,12,18,.20)",
        border: "1px solid rgba(28,46,73,.86)",
        // Mulden-/Kantenmix: außen subtil, innen Tiefe
        boxShadow: [
          "inset 0 -1px 3px rgba(255,255,255,.40)", // obere Innenkante
          "inset 0 3px 2px rgba(0,0,0,.50)",        // Schatten nach innen
          "0 0 1px rgba(0,0,0,.25)",               // feine Außenkante
        ].join(", "),
        color: "#e6edf3",
        // WICHTIG: KEIN padding hier – neutral!
        boxSizing: "border-box",
        ...style,
      }}
    >
      {title ? (
        <div
          style={{
            textAlign: "center",
            color: "rgba(233,241,255,.95)",
            letterSpacing: ".18em",
            fontWeight: 800,
            fontSize: 14,
            textTransform: "uppercase",
            userSelect: "none",
            margin: "0 0 8px 0",
            ...titleStyle,
          }}
        >
          {title}
        </div>
      ) : null}

      {/* Neutraler Innen-Container. Kein Zwangs-Padding. */}
      <div
        className="in"
        style={{
          position: "relative",
          minWidth: 0,
          boxSizing: "border-box",
          ...contentStyle,
        }}
      >
        {children}
      </div>
    </section>
  );
}
